// Reflect — short journaling prompt that updates the Ikigai profile.
// One question per session; tagging is optional. XP is awarded by the reducer.
// Neo-fintech surface to match the rest of the daily loop.

import { useState } from 'react';
import { useDispatch } from '@biz-kid/store';
import { Card, Eyebrow, Button } from '../../ui/kit.js';

export type ReflectProps = {
  onDone: () => void;
};

export function Reflect({ onDone }: ReflectProps) {
  const [entry, setEntry] = useState('');
  const dispatch = useDispatch();
  const canSave = entry.trim().length > 0;

  return (
    <Card>
      <Eyebrow color="var(--brand)">REAL TALK</Eyebrow>
      <h2 style={{ margin: '6px 0 4px', fontSize: 22, fontWeight: 900, color: 'var(--text)', letterSpacing: '-0.01em' }}>
        WHAT HIT DIFFERENT TODAY?
      </h2>
      <p style={{ margin: 0, fontSize: 13.5, color: 'var(--text-2)', lineHeight: 1.5 }}>
        Money's one part. What else mattered?
      </p>

      <textarea
        value={entry}
        onChange={(e) => setEntry(e.target.value)}
        rows={4}
        placeholder="One line. Keep it real."
        style={{
          marginTop: 16,
          width: '100%',
          padding: '12px 14px',
          borderRadius: 12,
          border: '1px solid var(--border)',
          background: 'var(--surface-2)',
          color: 'var(--text)',
          fontFamily: 'inherit',
          fontSize: 14.5,
          lineHeight: 1.5,
          resize: 'none',
          outline: 'none',
          boxSizing: 'border-box',
        }}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14 }}>
        <Button tone="ghost" onClick={onDone}>SKIP</Button>
        <Button
          tone="primary"
          disabled={!canSave}
          onClick={() => {
            dispatch({ kind: 'CompleteReflect', entry: entry.trim() });
            onDone();
          }}
        >
          SEND IT →
        </Button>
      </div>
    </Card>
  );
}
